import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import * as React from "react";

interface OwnProps {
    labelOverride?: string;
    extendedStyles?: ProductWhereToBuyLinkStyles;
}

type Props = OwnProps;

export interface ProductWhereToBuyLinkStyles {
    link?: LinkPresentationProps;
}

export const productWhereToBuyLinkStyles: ProductWhereToBuyLinkStyles = {};

/**
 * @deprecated Use productWhereToBuyLinkStyles instead.
 */
export const productWhereToBuyLink = productWhereToBuyLinkStyles;

const ProductWhereToBuyLink: React.FC<Props> = ({ labelOverride, extendedStyles, ...otherProps }) => {
    const [styles] = React.useState(() => mergeToNew(ProductWhereToBuyLink, extendedStyles));

    return (
        <Link {...styles.link} href="/locationfinder" {...otherProps} className="btn btn-tertiary btn-tertiary_small">
            {labelOverride ?? translate("Where to Buy")}
        </Link>
    );
};

export default ProductWhereToBuyLink;
